export default "__VITE_ASSET__c27268ce__"